<template>
    <div>
        <v-app-bar
        app
        color="#ed6103"
        flat
        absolute
        height="50"
        >
        <div class="mod-header__wrapper">
            <p class="mod-header__logo">
                <a href="https://www.homes.co.jp/">
                    <img :src="`${lifull_homes_white}?v=4da4b7c0da685f0af499acae81aca587`" alt="LIFULL HOME'S">
                </a>
            </p>
            <a class="mod-header__link" href="https://www.homes.co.jp/about/concept/">
                <span>日本最大級の不動産・</span>
                <span>住宅情報サイト</span>
            </a>
        </div>
        <v-spacer></v-spacer>
        </v-app-bar>
    </div>
</template>

<script>
import lifull_homes_white from '../assets/lifull_homes_white.svg';
export default {
    data(){
        return{
            lifull_homes_white
        }
    }
}
</script>

<style scoped>
.v-application p{
    margin-bottom: 0px !important;
}
.v-application a{
    color: white !important;
}
.mod-header__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0 16px;
  width: 100%;
  max-width: 972px;
  min-width: 320px;
  box-sizing: border-box;
  font-weight: bold;
  height: 50px;
}
.mod-header__logo img {
  width: 110px;
  height: 37px;
  transform: translateX(-9px);
  vertical-align: bottom;
}
.mod-header__link {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 11px;
  line-height: 1.4;
  text-decoration: none;
}
@media only screen and (min-width: 769px) {
  .mod-header__link {
    flex-direction: row;
    font-size: 12px;
  }
}
.v-toolbar__content{
    display: block!important;
}
</style>